import Index from "@/Pages/Admin/CourseRecords/Index"
import Bulk from "@/Pages/Admin/CourseRecords/BulkRecord"
import Create from "@/Pages/Admin/CourseRecords/Create"
import Edit from "@/Pages/Admin/CourseRecords/Edit"

export default [
    {
        path: '/admin/courses/:courseId/session-groups/:courseSessionGroupId/sessions/:courseSessionId/records',
        component: Index,
        name: 'admin.courses.session-groups.sessions.records.index',
        meta: {
            auth: true
        },
    },
    {
        path: '/admin/courses/:courseId/session-groups/:courseSessionGroupId/sessions/:courseSessionId/records/bulk',
        component: Bulk,
        name: 'admin.courses.session-groups.sessions.records.bulk',
        meta: {
            auth: true
        },
    },
    {
        path: '/admin/courses/:courseId/session-groups/:courseSessionGroupId/sessions/:courseSessionId/records/create/:courseApplicationId',
        component: Create,
        name: 'admin.courses.session-groups.sessions.records.create',
        meta: {
            auth: true
        },
    },
    {
        path: '/admin/courses/:courseId/session-groups/:courseSessionGroupId/sessions/:courseSessionId/records/:courseRecordId',
        component: Index,
        name: 'admin.courses.session-groups.sessions.records.show',
        meta: {
            auth: true
        },
    },
    {
        path: '/admin/courses/:courseId/session-groups/:courseSessionGroupId/sessions/:courseSessionId/records/:courseRecordId/edit',
        component: Edit,
        name: 'admin.courses.session-groups.sessions.records.edit',
        meta: {
            auth: true
        },
    },

];
